import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { tagsSelectors } from 'app-components/flux/tags';
import React from 'react';

import { useAppSelector } from 'hooks/redux';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  row: {
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    '> *': {
      lineHeight: '24px',
    },
    '>div': {
      borderRight: `1px ${theme.palette.divider} solid`,
      padding: `${theme.spacing(3)} ${theme.spacing(2)}`,
    },
    alignContent: 'flex-start',
    alignItems: 'center',
  },
  textPaddingAfter: {
    paddingRight: theme.spacing(0.5),
  },
  highlightText: {
    color: theme.palette.info.main,
  },
}));

const TagsTarget = ({ tagTargetIds }: { tagTargetIds?: string[] }) => {
  const { classes } = useStyles();

  const allTags = useAppSelector(tagsSelectors.getResourcesById);

  if (!tagTargetIds) {
    return <></>;
  }

  const tagNames = tagTargetIds?.reduce<string[]>((acc, id) => {
    const tagName = id && allTags?.get(id)?.name;
    tagName && acc.push(tagName);
    return acc;
  }, []);

  return (
    <>
      {tagNames.length > 0 && (
        <Box className={classes.row}>
          <Typography className={classes.textPaddingAfter} variant='bodyRegular'>
            Add Tag
          </Typography>

          {tagNames.map((tagName, index) => (
            <React.Fragment key={tagName}>
              <Typography className={classes.highlightText} variant='bodyMedium'>
                {tagName}
              </Typography>
              {index + 1 < tagNames.length && <Typography className={classes.textPaddingAfter}>,</Typography>}
            </React.Fragment>
          ))}
        </Box>
      )}
    </>
  );
};

export default TagsTarget;
